var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocketGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69 6.35047C7.65 8.64047 6.25 11.9305 6.12 12.2405L2.5 10.6905L6.55 6.64047C7.02 6.17047 7.7 5.96047 8.36 6.09047L9.69 6.35047ZM11.67 17.0005C11.67 17.0005 15.41 15.4505 17.56 13.3005C22.96 7.90047 22.06 3.68047 21.77 2.73047C20.82 2.43047 16.6 1.54047 11.2 6.94047C9.05 9.09047 7.5 12.8305 7.5 12.8305L11.67 17.0005ZM18.15 14.8105C15.86 16.8505 12.57 18.2505 12.26 18.3805L13.81 22.0005L17.86 17.9505C18.33 17.4805 18.54 16.8005 18.41 16.1405L18.15 14.8105ZM9.5 18.0005C9.5 18.8305 9.16 19.5805 8.62 20.1205C7.44 21.3005 2.5 22.0005 2.5 22.0005C2.5 22.0005 3.2 17.0605 4.38 15.8805C4.7988 15.4595 5.33325 15.1724 5.9155 15.0558C6.49775 14.9392 7.10153 14.9982 7.65017 15.2253C8.19882 15.4525 8.66758 15.8376 8.99694 16.3317C9.3263 16.8258 9.5014 17.4067 9.5 18.0005ZM13.5 9.00047C13.5 7.90047 14.4 7.00047 15.5 7.00047C16.6 7.00047 17.5 7.90047 17.5 9.00047C17.5 10.1005 16.6 11.0005 15.5 11.0005C14.4 11.0005 13.5 10.1005 13.5 9.00047Z",
    fill: "#28C18A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketGreen);
export default __webpack_public_path__ + "static/media/rocketGreen.f75ec49fc527205659deefb0d79910d2.svg";
export { ForwardRef as ReactComponent };